import React, { FunctionComponent } from 'react';
import Mac from './mac/Mac';
import Windows from './windows/Windows';
import Android from './android/Android';
import IOSComponent from './ios/IOSComponent';
import Styles from './OSPrivacySettings.module.scss';

const OSPrivacySettings: FunctionComponent = () => {
  return (
    <div className={Styles.osPrivacySettingsWrapper}>
      <div className={Styles.header}>
        <h2 className="fontTwentyFour poppins-bold text-black mb-20">
          Step 2: Check OS Privacy Settings
        </h2>
        <p className="fontSixteen poppins-regular text-gray mb-30">
          If browser settings don't work, check your operating system's privacy settings. Choose your device type below.
        </p>
      </div>

      <div className={Styles.osList}>
        <div className={Styles.osSection}>
          <div className={Styles.osHeader}>
            <h3 className="fontEighteen poppins-bold text-black mb-10">Mac</h3>
            <p className="fontFourteen poppins-regular text-gray">macOS Privacy & Security</p>
          </div>
          <Mac />
        </div>

        <div className={Styles.osSection}>
          <div className={Styles.osHeader}>
            <h3 className="fontEighteen poppins-bold text-black mb-10">Windows</h3>
            <p className="fontFourteen poppins-regular text-gray">Windows 10/11 Location Services</p>
          </div>
          <Windows />
        </div>

        <div className={Styles.osSection}>
          <div className={Styles.osHeader}>
            <h3 className="fontEighteen poppins-bold text-black mb-10">Android</h3>
            <p className="fontFourteen poppins-regular text-gray">Android Location Services</p>
          </div>
          <Android />
        </div>

        <div className={Styles.osSection}>
          <div className={Styles.osHeader}>
            <h3 className="fontEighteen poppins-bold text-black mb-10">iOS</h3>
            <p className="fontFourteen poppins-regular text-gray">iPhone, iPad Location Services</p>
          </div>
          <IOSComponent />
        </div>
      </div>
    </div>
  );
};

export default OSPrivacySettings;